module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/diploma.svg?0dfb4e0edb649260869ce104b91a6f1b";